// common
var MY_PROJECT = MY_PROJECT || {};
MY_PROJECT.COMMON = {};

//- **********************************************************************
//- ローディング処理(imagesloaded依存)
//- **********************************************************************
MY_PROJECT.COMMON.LOADING = {
  init: function() {
    this.setParameters();
    this.bindEvent();
  },
  setParameters: function() {
    this.loadedFlag = false;
    this.ticking = false;
    // ▼imagesloaded
    this.root = document.getElementsByTagName('html')[0];
    this.loadingElm = document.getElementById('js-loading');
    this.loadedImg = 0;
    this.imgLength = imagesLoaded('body', {background: true}).images.length;
    this.openingLayer = document.querySelector('.lp-opening__layer');
    this.progressCurrent = 0;
    this.timer;
    // ▼gsap
    this.homeDevelopment = document.getElementsByClassName('l-home-development__container')[0];
    if (this.homeDevelopment) {
      this.homeDevelopmentTrg = this.homeDevelopment.parentNode;
    }
    // this.homeDevelopmentItem = this.homeDevelopment.getElementsByClassName('p-store-list')[0];
  },
  bindEvent: function() {
    var myself = this;
    if (this.loadingElm) {
      imagesLoaded(this.loadingElm, function() {
        myself.timer = setInterval(myself.monitorProgress.bind(myself), 1000 / 50);
        imagesLoaded('body', {background: true}).on('progress', function() {
          myself.loadedImg++;
        });
      });
    }
  },
  monitorProgress: function() {
    var progressPer = (this.loadedImg / this.imgLength) * 100;
    this.progressCurrent += (progressPer - this.progressCurrent) * 0.1;
    // openingLayer.style.height = progressCurrent + '%';
    if (this.progressCurrent >= 100) {
      this.clearLoading();
    }
    if (this.progressCurrent > 99.9) {
      this.progressCurrent = 100 + 10;
    }
  },
  clearLoading: function() {
    clearInterval(this.timer);
    // window.scrollTo(0, 0);
    if (this.root) {
      this.root.classList.add('is-loaded');
    }
    this.animation();
    loadedFlag = true;
  },
  animation: function() {
    var myself = this;
    if (myself.homeDevelopment) {
      // var animTl = gsap.timeline();
      // var move;
      // move = (myself.homeDevelopment.clientWidth - myself.homeDevelopmentTrg.clientWidth);
      // move = (myself.homeDevelopmentItem.offsetWidth);
      // console.log(move);

      ScrollTrigger.saveStyles(myself.homeDevelopment);
      ScrollTrigger.matchMedia({
        '(min-width: 768px)': function() {
          gsap.to(myself.homeDevelopment, {
            // x: -(move),
            x: function(index, target, targets) { //function-based value
              // var hoge = target.clientWidth;
              // var fuga = target.parentNode.clientWidth;
              // var piyo = target.clientWidth - target.parentNode.clientWidth;
              // console.log(piyo);
              return '-' + (target.clientWidth - target.parentNode.clientWidth);
            },
            repeatRefresh: true,
            scrollTrigger: {
              trigger: myself.homeDevelopmentTrg,// 要素".b"がビューポートに入ったときにアニメーション開始
              start: 'top top',// アニメーション開始位置
              end: 'bottom+=3500',// アニメーション終了位置
              scrub: 1,// アニメーションをスクロール位置にリンクさせる
              pin: true,
              pinSpacing: true,
              // markers: true,
              invalidateOnRefresh: true,
              // onRefresh: function() {
              //   move = (myself.homeDevelopment.clientWidth - myself.homeDevelopmentTrg.clientWidth);
              //   // scrollTrigger.kill();
              //   // console.log(move);
              //   // gsap.to(myself.homeDevelopment, {
              //   //   x: -(move),
              //   // });
              // },
            }
          });
        },
      });
      // window.addEventListener('resize', function() {
      //   if (!myself.ticking) {
      //     requestAnimationFrame(function() {
      //       myself.ticking = false;
      //       animTl.kill();
      //       translateAnim();
      //     });
      //     myself.ticking = true;
      //   }
      // }, false);
      // translateAnim();
      // gsap.to(this.homeDevelopment, {
      //   x: -(move),
      //   scrollTrigger: {
      //     trigger: this.homeDevelopmentTrg, // 要素".b"がビューポートに入ったときにアニメーション開始
      //     start: 'top top', // アニメーション開始位置
      //     end: 'bottom+=3500', // アニメーション終了位置
      //     scrub: 1,// アニメーションをスクロール位置にリンクさせる
      //     pin: true,
      //     pinSpacing: true,
      //     // markers: true
      //   }
      // });
    }
    // function translateAnim() {
    //   // myself.homeDevelopment.scrollLeft = 0;
    //   // myself.homeDevelopment.style.transform = 'none';
    //   move = (myself.homeDevelopment.offsetWidth - myself.homeDevelopmentTrg.offsetWidth);
    //   console.log('translateAnim!');
    //   console.log(move);
    //   animTl.to(myself.homeDevelopment, {
    //     x: -(move),
    //     // xPercent: -100,
    //     scrollTrigger: {
    //       trigger: myself.homeDevelopmentTrg,// 要素".b"がビューポートに入ったときにアニメーション開始
    //       start: 'top top',// アニメーション開始位置
    //       end: 'bottom+=3500',// アニメーション終了位置
    //       scrub: 1,// アニメーションをスクロール位置にリンクさせる
    //       pin: true,
    //       pinSpacing: true,
    //       // markers: true
    //     }
    //   });
    // }
  },
}

//- **********************************************************************
//- グローバルナビ
//- **********************************************************************
MY_PROJECT.COMMON.GNAV = {
  init: function() {
    this.setParameters();
    this.bindEvent();
  },
  setParameters: function() {
    // gnav
    this.root = document.querySelector('html');
    this.trg = document.getElementById('js-gnav-trg');
    this.gnav = document.getElementById('js-gnav');
    if (this.gnav) {
      this.gnavItem = this.gnav.getElementsByClassName('js-gnav__divider');
    }
  },
  bindEvent: function() {
    var myself = this;
    // gnav
    if (this.trg) {
      this.trg.addEventListener('click', function() {
        if (this.classList.contains('is-active')) {
          myself.hideNav(myself.gnav, 'is-active');
          this.classList.remove('is-active');
        } else {
          myself.appearNav(myself.gnav, 'is-active');
          this.classList.add('is-active');
        }
      }, false);
    }
    if (this.gnavItem.length) {
      for (var i = 0; i < this.gnavItem.length; i++) {
        this.gnavItem[i].addEventListener('mouseenter', function() {
          this.classList.add('is-hover');
        }, false);
        this.gnavItem[i].addEventListener('mouseleave', function() {
          this.classList.remove('is-hover');
        }, false);
      }// for (var i = 0; i < this.gnavItem.length; i++) {
    }
  },
  hideNav: function(target, className) {
    this.root.classList.remove('is-locked');
    if (target) {
      target.classList.remove(className);
    }
  },
  appearNav: function(target, className) {
    this.root.classList.add('is-locked');
    if (target) {
      target.classList.add(className);
    }
  },
};// MY_PROJECT.COMMON.GNAV = {


//- **********************************************************************
//- スクロール処理
//- https://syncer.jp/javascript-reference/element/scrolltop
//- **********************************************************************
MY_PROJECT.COMMON.SCROLL = {
  init: function() {
    this.setParameters();
    this.bindEvent();
  },
  setParameters: function() {
    this.ticking = false;
    this.root = document.querySelector('html');
    this.header = document.getElementById('js-header');
    this.headerTrg = document.getElementById('js-header-trg');
    this.headerTrgPos = 0;
    this.headerTrgClientRect = 0;
    this.scrollPos = 0;
    this.offset = 0;
    this.inviewElm = document.getElementsByClassName('js-inview');
  },
  bindEvent: function() {
    var myself = this;
      window.addEventListener('scroll', function() {
        if (myself.header && !myself.ticking) {
          requestAnimationFrame(function() {
            myself.ticking = false;
            myself.scrollPos = window.pageYOffset;
            myself.checkSiteScrolled();
            myself.toggleHeaderState();
          });
          myself.ticking = true;
        }
        if (myself.inviewElm.length) {
          inView.offset({
            bottom: 100
          });
          inView('.js-inview').on('enter', function($target) {
            // $target.classList.add('effect-is-active');
            $target.classList.add('in-view');
          });
        }
      }, false);
  },
  checkSiteScrolled: function() {
    // 下方向にスクロールしているとき
    if (this.scrollPos > this.offset) {
      if (this.root.classList.contains('site-scroll-up')) {
        this.root.classList.remove('site-scroll-up');
        this.root.classList.add('site-scroll-down');
      } else if (!this.root.classList.contains('site-scroll-down')) {
        this.root.classList.add('site-scroll-down');
      }
    // 上方向にスクロールしているとき
    } else {
      if (this.root.classList.contains('site-scroll-down')) {
        this.root.classList.remove('site-scroll-down');
        this.root.classList.add('site-scroll-up');
      } else if (!this.root.classList.contains('site-scroll-up')) {
        this.root.classList.add('site-scroll-up');
      }
    }
    this.offset = this.scrollPos;
  },
  toggleHeaderState: function() {
    myself = this;
    if (this.headerTrg) {
      this.headerTrgClientRect = this.headerTrg.getBoundingClientRect();
      this.headerTrgPos = this.scrollPos + this.headerTrgClientRect.top;
    } else {
      this.headerTrgPos = 0;
    }
    if (this.scrollPos > this.headerTrgPos) {
      this.header.classList.add('is-fixed');
      setTimeout(function() {
        myself.root.classList.add('header-is-fixed');
      }, 500);
    } else {
      this.header.classList.remove('is-fixed');
      this.root.classList.remove('header-is-fixed');
    }
  }
};// MY_PROJECT.COMMON.SCROLL = {


//- **********************************************************************
//- 横スクロール(jquery.mousewheel依存) => マウススクロールに変更
//- https://
//- **********************************************************************
MY_PROJECT.COMMON.HORIZONTALLYSCROLL = {
  init: function() {
    this.setParameters();
    this.bindEvent();
  },
  setParameters: function() {
    this.target = document.getElementById('js-mouse-scroll');
    var myself = this;
    if (this.target) {
      this.container = document.getElementById('js-mouse-scroll__container');
      this.item = this.container.getElementsByClassName('js-mouse-scroll__item');
      this.fps = 1000 / 60 >> 0;//FPS (60にある数字が大きい程滑らかに動くけど、重たくなる)
      this.maxSpd = 24;//移動速度の最大値
      this.defaultSpd = 1;//移動速度のデフォルト値
      this.spd = this.defaultSpd;//現在の移動速度
      this.ticking = false;
      this.mediaQuery = window.matchMedia('screen and (min-width: 768px)');
      // this.mediaQuery = 768;
      this.timerID = null;
      this.isAnimated = false;
      this.targetW = this.target.clientWidth;
      this.targetL = this.target.getBoundingClientRect().left;
      this.xMove = 0;//要素のX移動値
      this.xMouse = 0;//マウスのX移動値
      this.perMove = 0;
      this.containerW = 0;
      initSize();
      myself.mediaQuery.addEventListener('change', initSize, false);
      window.addEventListener('resize', function() {
        if (!myself.ticking) {
          requestAnimationFrame(function() {
            myself.ticking = false;
            initSize();
          });
          myself.ticking = true;
        }
      }, false);
    }// if (this.target.length) {
    function initSize() {
      if (myself.mediaQuery.matches) {
        myself.targetW = myself.target.clientWidth;
        if (myself.container) {
          myself.containerW = 0;
          if (myself.item.length) {
            for (var i = 0; i < myself.item.length; i++) {
              myself.containerW += myself.item[i].clientWidth;
            }
            myself.container.style.width = myself.containerW + 'px';
          }
        }
        myself.xEnd = (myself.container.clientWidth - myself.targetW) * -1;// 右端の終点位置を計算します
      } else {
        myself.container.style.width = '';
        myself.container.style.left = '';
        myself.container.style.transform = '';
      }// if (this.mediaQuery.matches)
    }
  },
  bindEvent: function() {
    var myself = this;
    if (myself.target) {
      myself.target.addEventListener('mouseenter', function(e) {
        if (myself.mediaQuery.matches) {
          myself.container.style.willChange = 'transform';

          myself.timerID = setInterval(function() {
            myself.xMove = myself.xMove - myself.spd;
            if (myself.xMove > 0) {// 左端を超えたら
              myself.xMove = 0;
            } else if (myself.xMove < myself.xEnd) {// 右端を超えたら
              myself.xMove = myself.xEnd;
            }
            // 計算した移動値を反映
            // console.log(myself.xMove);
            myself.container.style.transform = 'translateX(' + myself.xMove + 'px)';
          }, myself.fps);
        } else {
          console.log('mouseenter メディアクエリ指定外');
        }
      }, false);
      myself.target.addEventListener('mousemove', function(e) {
        if (myself.mediaQuery.matches) {
          if (!myself.isAnimated) {
            requestAnimationFrame(function() {
              myself.isAnimated = false;
              myself.xMouse = e.clientX - myself.targetL;
              myself.perMove = Math.floor((myself.xMouse / myself.targetW) * 100);
              myself.perMove = (myself.perMove / 50) - 1;
              myself.spd = myself.maxSpd * myself.perMove;
              // console.log(myselfL);
              // var spd = myself.defaultSpd;//現在の移動速度
            });
            myself.isAnimated = true;
          }
        } else {
          console.log('mousemove メディアクエリ指定外');
        }
      }, false);
      myself.target.addEventListener('mouseleave', function() {
        if (myself.mediaQuery.matches) {
          clearInterval(myself.timerID);
          myself.container.style.willChange = '';
          myself.spd = myself.defaultSpd;
        } else {
          console.log('mouseleave メディアクエリ指定外');
        }
      }, false);
    }
  },
}


//- **********************************************************************
//- パネル(トップページ)
//- https://
//- **********************************************************************
MY_PROJECT.COMMON.PANEL = {
  init: function() {
    this.setParameters();
    this.bindEvent();
  },
  setParameters: function() {
    this.target = document.getElementsByClassName('js-panel');
  },
  bindEvent: function() {
    var item;
    var image;
    var order;
    var wrap;
    if (this.target.length) {
      for (var i = 0; i < this.target.length; i++) {
        wrap = this.target[i];
        item = this.target[i].getElementsByClassName('js-panel__item');
        image = this.target[i].getElementsByClassName('js-panel__image');
        if (item.length && image.length) {

          this.target[i].addEventListener('mouseenter', function() {
            this.classList.add('is-hover');
          }, false);
          this.target[i].addEventListener('mouseleave', function() {
            this.classList.remove('is-hover');
            for (var j = 0; j < item.length; j++) {
              item[j].classList.remove('is-active');
            }
            for (var k = 0; k < image.length; k++) {
              image[k].classList.remove('is-active');
            }
          }, false);

          for (var j = 0; j < item.length; j++) {
            item[j].addEventListener('mouseenter', function() {
              order = this.getAttribute('data-panel-item-order');
              if (!wrap.classList.contains('is-hover') ) {
                wrap.classList.add('is-hover');
              }
              for (var k = 0; k < item.length; k++) {
                item[k].classList.remove('is-active');
              }
              for (var l = 0; l < image.length; l++) {
                image[l].classList.remove('is-active');
              }
              if (!this.classList.contains('is-disabled')) {
                this.classList.add('is-active');
                for (var m = 0; m < image.length; m++) {
                  if (image[m].getAttribute('data-panel-image-order') === order) {
                    image[m].classList.add('is-active');
                  }
                }
              } else {
                wrap.classList.remove('is-hover');
              }
            }, false);
          }

        }// if (item.length && image.length) {
      }// for (var i = 0; i < this.target.length; i++) {
    }// if (this.target.length) {
  }// bindEvent: function() {
}



//- **********************************************************************
//- スクロールバー
//- simplebar依存
//- **********************************************************************
// MY_PROJECT.COMMON.SCROLLBAR = {
//   init: function() {
//     this.setParameters();
//     this.bindEvent();
//   },
//   setParameters: function() {
//     this.target = document.getElementsByClassName('js-scrollbar');
//   },
//   bindEvent: function() {
//     if (this.target.length) {
//       for (var i = 0; i < this.target.length; i++) {
//         new SimpleBar(this.target[i]);
//       }
//     }
//   },
// }


document.addEventListener('DOMContentLoaded', function() {
  MY_PROJECT.COMMON.LOADING.init();
  MY_PROJECT.COMMON.SCROLL.init();
  MY_PROJECT.COMMON.GNAV.init();
  MY_PROJECT.COMMON.HORIZONTALLYSCROLL.init();
  MY_PROJECT.COMMON.PANEL.init();
  // MY_PROJECT.COMMON.SCROLLBAR.init();
}, false);

// window.addEventListener('load', function() {
  // MY_PROJECT.COMMON.OPTIONTABLE.init();
// }, false);

//- **********************************************************************
//- map機能使用時
//- リサイズ処理
//- **********************************************************************
document.addEventListener("DOMContentLoaded", function () {
  if (typeof imageMapResize === "function") {
    imageMapResize();
  }
});
